import api from "./index";

export async function getItems(params) {
  return api.get("/items", { params });
}

export async function useItem(itemID, body) {
  return api.post(`/items/${itemID}/use`, body);
}

export async function getItemID(itemID) {
  return api.get(`/items/${itemID}`);
}
